<template>

  <div v-loading='loading'>

    <!-- 域名购买时间筛选 -->
    <el-date-picker class="bbb" v-model="time_" type="date" placeholder="选择购买日期" size="mini"></el-date-picker>

    <!-- 主站筛选 -->
    <el-select class="bbb" v-model="ZhuZhanValue" placeholder="请选择主站" size="mini" clearable>
      <el-option
        v-for="item in ZhuZhan"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>

    <!-- 博客域名筛选 -->
    <el-input class="aaa" v-model="blog" placeholder="请输入博客域名" size="mini" clearable></el-input>

    <!-- 权重得分筛选 -->
    <el-input class="aaa" v-model="weight" placeholder="请输入权重得分" size="mini" clearable></el-input>

    <!-- 关键词筛选 -->
    <el-input class="aaa" v-model="keywords_" placeholder="请输入关键词" size="mini" clearable></el-input>

    <!-- 搜索按钮 -->
    <el-button type="primary" size="mini" @click="SEARCH" icon="el-icon-search">搜索</el-button>

    <!-- 新增按钮 -->
    <el-button type="primary" size="mini" @click="ADD" icon="el-icon-plus" v-if="UN == 'niushaoyun' ? true : false">新增</el-button>

    <!-- 主体表格 -->
    <el-table
      height="750"
      :data="tableData" 
      style="border: 1px solid #000000; width:100%; margin-top:20px"
      :cell-style="{padding:1,borderColor:'#000000'}"
      :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
      stripe
      border
      fit>
      <el-table-column prop="zzym" label="主站域名" width="" align="center"> </el-table-column>
      <el-table-column prop="gmrq" label="购买日期" width="" align="center"> </el-table-column>
      <el-table-column prop="dqrq" label="到期日期" width="" align="center"> </el-table-column>
      <el-table-column prop="dj" label="单价" width="" align="center"> </el-table-column>
      <el-table-column prop="bkhtym" label="博客后台域名" width="" align="center"> </el-table-column>
      <el-table-column prop="zh" label="账号" width="" align="center">
        <template slot-scope="scope">
          {{scope.row.zh}}
          <el-tag type="success" size="mini" @click="copyText(scope.row.zh)" >
            复制
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mm" label="密码" width="" align="center">
        <template slot-scope="scope">
          {{scope.row.mm}}
          <el-tag type="success" size="mini" @click="copyText(scope.row.mm)" >
            复制
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="qz" label="权重" width="" align="center"> </el-table-column>
      <el-table-column prop="zt" label="主题" width="" align="center"> </el-table-column>
      <el-table-column prop="zxr" label="执行人" width="" align="center"> </el-table-column>
      <el-table-column prop="bktjfs" label="博客添加方式" width="" align="center"> </el-table-column>
      <el-table-column prop="gxzps" label="更新总篇数" width="" align="center"> </el-table-column>
      <el-table-column prop="zjgxrq" label="最近更新日期" width="" align="center"> </el-table-column>
      <el-table-column label="外链采集" align="center">
        <el-table-column prop="znsygjc" label="当前主站所有博客网站下出现的关键词数量" width="" align="center">
        </el-table-column>
        <el-table-column prop="znsymwblj" label="当前主站所有博客网站下出现的锚文本链接数量" width="" align="center">
        </el-table-column>
        <el-table-column prop="sysl" label="当前主站数量" width="" align="center">
        </el-table-column>
        <el-table-column prop="dqbkgjc" label="当前博客网站下出现的关键词数量" width="" align="center">
        </el-table-column>
        <el-table-column prop="dqbkmwblj" label="当前博客网站下出现的锚文本链接数量" width="" align="center">
        </el-table-column>
        <el-table-column prop="znsl" label="当前博客网站下数量" width="" align="center">
        </el-table-column>
      </el-table-column>

      <el-table-column fixed="right" align="center" label="操作" width="80vw" v-if="UN == 'niushaoyun' ? true : false">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" icon="el-icon-view" @click="view(scope.$index, scope.row)">查看</el-link>
          <el-link type="success" :underline="false" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-link>
          <el-link type="danger" :underline="false" icon="el-icon-delete" @click="delete_(scope.$index, scope.row)">删除</el-link>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[1, 2, 3, 10]"
      :page-size="PS"
      layout="total, sizes, prev, pager, next, jumper"
      :total="TOTAL"
      style="display:flex; justify-content: center;">
    </el-pagination>

    <!-- 新增域名对话框 -->
    <el-dialog title="新增域名信息" :visible.sync="xz_dialog_domin" width="40%">
      <el-form :model="form" :inline="true" size="mini">

        <el-form-item label="主站域名" :label-width="formLabelWidth">
          <el-select v-model="form.zzym" placeholder="请选择主站域名" style="width: 240px;" clearable>
            <el-option
              v-for="item in ZhuZhan"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="购买日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.gmrq"
            type="date"
            placeholder="选择购买日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="到期日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.dqrq"
            type="date"
            placeholder="选择到期日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="单价" :label-width="formLabelWidth">
          <el-input v-model="form.dj" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="博客后台域名" :label-width="formLabelWidth">
          <el-input v-model="form.bkhtym" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="form.zh" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.mm" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="权重" :label-width="formLabelWidth">
          <el-input v-model="form.qz" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="主题" :label-width="formLabelWidth">
          <el-input v-model="form.zt" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="执行人" :label-width="formLabelWidth">
          <el-select v-model="form.zxr" placeholder="请选择执行人" style="width: 240px;" clearable>
            <el-option
              v-for="item in ZXR"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="博客添加方式" :label-width="formLabelWidth">
          <el-select v-model="form.bktjfs" placeholder="请选择博客添加方式" style="width: 240px;" clearable>
            <el-option
              v-for="item in BKTJFS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="更新总篇数" :label-width="formLabelWidth">
          <el-input v-model="form.gxzps" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="最近更新日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.zjgxrq"
            type="date"
            placeholder="选择最近更新日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="关键词" :label-width="formLabelWidth">
          <el-input v-model="form.gjc_value" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="锚文本链接" :label-width="formLabelWidth">
          <el-input v-model="form.mwblj_value" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="xz_dialog_domin = false">取 消</el-button>
        <el-button type="primary" @click="XZYM">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑域名对话框 -->
    <el-dialog title="编辑域名信息" :visible.sync="bj_dialog_domin" width="40%">
      <el-form :model="form" :inline="true" size="mini">

        <el-form-item label="主站域名" :label-width="formLabelWidth">
          <el-select v-model="form.zzym" placeholder="请选择主站域名" style="width: 240px;" clearable>
            <el-option
              v-for="item in ZhuZhan"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="购买日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.gmrq"
            type="date"
            placeholder="选择购买日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="到期日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.dqrq"
            type="date"
            placeholder="选择到期日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="单价" :label-width="formLabelWidth">
          <el-input v-model="form.dj" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <!-- <el-form-item label="博客后台域名" :label-width="formLabelWidth">
          <el-input v-model="form.bkhtym" autocomplete="off" style="width: 240px;"></el-input>
        </el-form-item> -->

        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="form.zh" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.mm" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="权重" :label-width="formLabelWidth">
          <el-input v-model="form.qz" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="主题" :label-width="formLabelWidth">
          <el-input v-model="form.zt" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="执行人" :label-width="formLabelWidth">
          <el-select v-model="form.zxr" placeholder="请选择执行人" style="width: 240px;" clearable>
            <el-option
              v-for="item in ZXR"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="博客添加方式" :label-width="formLabelWidth">
          <el-select v-model="form.bktjfs" placeholder="请选择博客添加方式" style="width: 240px;" clearable>
            <el-option
              v-for="item in BKTJFS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="更新总篇数" :label-width="formLabelWidth">
          <el-input v-model="form.gxzps" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="最近更新日期" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.zjgxrq"
            type="date"
            placeholder="选择最近更新日期"
            size="mini"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="关键词" :label-width="formLabelWidth">
          <el-input v-model="form.gjc_value" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="锚文本链接" :label-width="formLabelWidth">
          <el-input v-model="form.mwblj_value" autocomplete="off" style="width: 240px;" clearable></el-input>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bj_dialog_domin = false">取 消</el-button>
        <el-button type="primary" @click="qdbjym">确 定</el-button>
        <!-- :disabled="isFormChanged" -->
      </div>
    </el-dialog>

    <!-- 删除域名对话框 -->
    <el-dialog title="提示" :visible.sync="sc_dialog_domain" width="30%">
      <span>确定删除吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sc_dialog_domain = false">取 消</el-button>
        <el-button type="primary" @click="SCYM">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看对话框 -->
    <el-dialog title="外链采集" :visible.sync="OUTck_dialog_domain">

      <el-dialog
        width="50%"
        title="当前主站"
        :visible.sync="IN1ck_dialog_domain"
        append-to-body>
        <el-table
          border
          :data="Row_Data"
          style="border: 1px solid #000000; width:100%; margin-top:20px"
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000',color:'#0099ff'}">
          <el-table-column property="gjc_value" label="主站内所有博客关键词" width="" align="center"></el-table-column>
          <el-table-column property="mwblj_value" label="主站内所有博客锚文本链接" width="" align="center"></el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog
        width="50%"
        title="当前博客"
        :visible.sync="IN2ck_dialog_domain"
        append-to-body>
        <el-table
          border
          :data="Row_Data"
          style="border: 1px solid #000000; width:100%; margin-top:20px"
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000',color:'#0099ff'}">
          <el-table-column property="dqgjc" label="当前博客内所有关键词" width="" align="center"></el-table-column>
          <el-table-column property="dqmwblj" label="当前博客内所有锚文本链接" width="" align="center"></el-table-column>
        </el-table>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ckdqzz">查看当前主站</el-button>
        <el-button type="primary" @click="ckdqbk">查看当前博客</el-button>
        <el-button @click="OUTck_dialog_domain = false">取 消</el-button>
      </div>

    </el-dialog>

  </div>

</template>

<script>
import { AddDomain,GetDomain,DeleteDomain,Get_gjc_mwblj,editDomain } from '../../api/api'
export default {

    data() {
      return {
        // 查看时所需主站参数
        zzparams:'',
        // 每行数据
        Row_Data:[],
        // 每页条数
        PS:10,
        // 总条数
        TOTAL:400,
        // 页面默认展示哪一页
        currentPage: 1,
        // 用户名
        UN:'',
        // 加载动画
        loading: true,
        // 购买时间
        time_: '',
        // 主站值
        ZhuZhanValue: '',
        // 博客值
        blog: '',
        // 权重得分
        weight: '',
        // 关键词
        keywords_: '',
        // 主体表格数据
        tableData: [],
        // 主站选项
        ZhuZhan: [{ label: 'https://madrid-shop.cn/', value: 'https://madrid-shop.cn/' }, { label: 'https://www.cuirz.com/', value: 'https://www.cuirz.com/' }, { label: 'https://www.nihonbro.com/', value: 'https://www.nihonbro.com/' }, { label: 'https://www.jleague-shop.com/', value: 'https://www.jleague-shop.com/' }, { label: 'https://www.supermaillot.com/', value: 'https://www.supermaillot.com/' }, { label: 'https://www.fortmaillot.com/', value: 'https://www.fortmaillot.com/' }, { label: 'https://www.kickitshirts.com/', value: 'https://www.kickitshirts.com/' }, { label: 'https://www.mailloten.com/', value: 'https://www.mailloten.com/' }, { label: 'https://www.ligafoot.com/', value: 'https://www.ligafoot.com/' }, { label: 'https://www.beazl.com/', value: 'https://www.beazl.com/' }, { label: 'https://www.top-w.com/', value: 'https://www.top-w.com/' }],
        // 手写/AI
        BKTJFS:[{ label: '手写', value: '手写'}, { label: 'AI', value: 'AI'}, { label: '采集', value: '采集'}],
        // 执行人
        ZXR:[{ label: '牛少云', value: '牛少云'}, { label: '赵蕊', value: '赵蕊'}, { label: '王丹', value: '王丹'}, { label: '张时凡', value: '张时凡'}, { label: '王利辰', value: '王利辰'}, { label: '余武康', value: '余武康'}, { label: '贾鹏伟', value: '贾鹏伟'}],
        // 新增域名对话框的状态
        xz_dialog_domin:false,
        // 编辑域名对话框的状态
        bj_dialog_domin:false,
        // 删除域名对话框的状态
        sc_dialog_domain:false,
        // 查看域名对话框的状态(外层)
        OUTck_dialog_domain:false,
        // 查看域名对话框的状态(内层当前主站)
        IN1ck_dialog_domain:false,
        // 查看域名对话框的状态(内层当前博客)
        IN2ck_dialog_domain:false,
        // 新增信息
        form: {
          zzym: '',
          gmrq: '',
          dqrq: '',
          dj: '',
          bkhtym: '',
          zh: '',
          mm: '',
          qz: '',
          zt: '',
          zxr: '',
          bktjfs: '',
          gxzps: '',
          zjgxrq: '',
          gjc_value: '',
          mwblj_value: '',
        },
        // form表单信息头默认宽度
        formLabelWidth: '100px',
        // 删除域名需要的参数
        sc_domain_params:{},
      }
    },

    created () {

      var un = window.localStorage.getItem('un');
      this.UN = un;
      if(un == '' || un == null || un == undefined){
        this.loading = true;
        return false;
      };
      this.getDomain();

    },

    methods: {

      // 获取域名
      getDomain(){
        var params = {
          time_:this.time_,
          ZhuZhanValue:this.ZhuZhanValue,
          blog:this.blog,
          weight:this.weight,
          keywords_:this.keywords_,
          currentPage:this.currentPage,
          PS:this.PS,
          flag:1
        }
        if(params.time_ !== ''){
          params.time_ = this.$moment(new Date(params.time_)).format('YYYY-MM-DD');
        }
        GetDomain(params).then(res => {
          // console.log(res);
          this.tableData = res.data;
          this.TOTAL = res.count;
          this.loading = false;
        })
      },

      // 设置每页条数
      handleSizeChange(val) {
        this.loading = true;
        this.PS = val;
        var params = {
          time_:this.time_,
          ZhuZhanValue:this.ZhuZhanValue,
          blog:this.blog,
          weight:this.weight,
          keywords_:this.keywords_,
          currentPage:this.currentPage,
          PS:this.PS,
          flag:1
        }
        if(params.time_ !== ''){
          params.time_ = this.$moment(new Date(params.time_)).format('YYYY-MM-DD');
        }
        GetDomain(params).then(res => {
          console.log(res);
          this.tableData = res.data;
          this.TOTAL = res.count;
          this.loading = false;
        })
      },

      // 跳转到哪一页
      handleCurrentChange(val) {
        this.loading = true;
        this.currentPage = val;
        var params = {
          time_:this.time_,
          ZhuZhanValue:this.ZhuZhanValue,
          blog:this.blog,
          weight:this.weight,
          keywords_:this.keywords_,
          currentPage:this.currentPage,
          PS:this.PS,
          flag:1
        }
        if(params.time_ !== ''){
          params.time_ = this.$moment(new Date(params.time_)).format('YYYY-MM-DD');
        }
        GetDomain(params).then(res => {
          console.log(res);
          this.tableData = res.data;
          this.TOTAL = res.count;
          this.loading = false;
        })
      },

      // 点击复制
      copyText (copytext) {
        const text = document.createElement('input'); // 创建节点
        text.setAttribute('readonly', 'readonly');
        text.value = copytext; // 赋值
        document.body.appendChild(text); // 插入节点
        text.setSelectionRange(0, text.value.length);
        text.select(); // 选中节点
        document.execCommand('copy'); // 执行浏览器复制方法
        if (document.body.removeChild(text)) {
          this.$message({ type: 'success', message: '复制成功' })
        } else {
          this.$message({ type: 'error', message: '复制失败' })
        }
      },

      // 新增
      ADD () {
        this.form = {};
        this.xz_dialog_domin = true;
      },

      // 确定新增
      XZYM (){
        
        if(
          this.form.bkhtym === undefined ||
          this.form.zzym === undefined ||
          this.form.gmrq === undefined ||
          this.form.dqrq === undefined ||
          this.form.dj === undefined ||
          this.form.zh === undefined ||
          this.form.mm === undefined ||
          // this.form.qz === '' ||
          this.form.zt === undefined ||
          this.form.zxr === undefined ||
          this.form.bktjfs === undefined ||
          this.form.gxzps === undefined ||
          this.form.zjgxrq === undefined ||
          this.form.gjc_value === undefined ||
          this.form.mwblj_value === undefined
          ){
            this.$message.error('表单信息填写不完整，请检查后确认提交！！！');
            return false;
        }

        var s = this.form.gjc_value.split(', ');
        var p = this.form.mwblj_value.split(' ');
        if(s.length !== p.length){
          this.$message.error('关键词数量和锚文本数量不一致，请检查后确认提交！！！');
          return false;
        }

        this.loading = true;
        var params = this.form;
        params.gmrq = this.$moment(new Date(this.form.gmrq)).format('YYYY-MM-DD');
        params.dqrq = this.$moment(new Date(this.form.dqrq)).format('YYYY-MM-DD');
        params.zjgxrq = this.$moment(new Date(this.form.zjgxrq)).format('YYYY-MM-DD');
        params.flag = '1';
        // console.log(params);
        AddDomain(params).then(res => {
          if(res.code == 200){
            this.$message({
              message:res.msg,
              type:'success'
            })
            this.getDomain();
          }else{
            this.$message({
              message:res.msg,
              type:'error'
            })
            this.loading = false;
          }
        })
        this.xz_dialog_domin = false;

      },

      // 搜索
      SEARCH () {
        this.loading = true;
        // console.log('1:' + this.time_ + typeof this.time_,'2:' + this.ZhuZhanValue + typeof this.ZhuZhanValue,'3:' + this.blog + typeof this.blog,'4:' + this.weight + typeof this.weight,'5:' + this.keywords_ + typeof this.keywords_);
        if(this.time_ === '' && this.ZhuZhanValue === '' && this.blog === '' && this.weight === '' && this.keywords_ === ''){
          this.$message({
            message: '搜索内容为空',
            type: 'warning'
          });
          this.loading = false;
          return false;
        }
        var params = {
          time_:this.time_,
          ZhuZhanValue:this.ZhuZhanValue,
          blog:this.blog,
          weight:this.weight,
          keywords_:this.keywords_,
          currentPage:this.currentPage,
          PS:this.PS,
          flag:1
        }
        if(params.time_ !== ''){
          params.time_ = this.$moment(new Date(params.time_)).format('YYYY-MM-DD');
        }
        // console.log(params);
        GetDomain(params).then(res => {
          // console.log(res);
          this.tableData = res.data;
          this.TOTAL = res.count;
          this.loading = false;
        })
      },

      // 查看
      view(index,row){
        this.zzparams ={
          zzym:row.zzym
        }
        var s = row.gjc_value.split(', ');
        var p = row.mwblj_value.split(' ');
        var b = [];
        s.forEach((item,index) => {
          b.push({
            dqgjc:item,
            dqmwblj:p[index]
          })
        })
        this.Row_Data = b;
        this.OUTck_dialog_domain = true;
      },

      // 查看当前主站
      ckdqzz(){
        Get_gjc_mwblj(this.zzparams).then(res => {
          var ccc = [];
          for(var i = 0;i < res.data.length;i++){
            var aaa = res.data[i].gjc_value.split(', ');
            var bbb = res.data[i].mwblj_value.split(' ');
            aaa.forEach((item,index) => {
              ccc.push({
                gjc_value:item,
                mwblj_value:bbb[index]
              })
            })
          }
          this.Row_Data = ccc;
        })
        this.IN1ck_dialog_domain = true;
      },

      // 查看当前博客
      ckdqbk(){
        this.IN2ck_dialog_domain = true;
      },

      // 编辑
      edit(index,row){
        // console.log(index,row);
        this.form = {
          zzym: row.zzym,
          gmrq: row.gmrq,
          dqrq: row.dqrq,
          dj: row.dj,
          bkhtym: row.bkhtym,
          zh: row.zh,
          mm: row.mm,
          qz: row.qz,
          zt: row.zt,
          zxr: row.zxr,
          bktjfs: row.bktjfs,
          gxzps: row.gxzps,
          zjgxrq: row.zjgxrq,
          gjc_value: row.gjc_value,
          mwblj_value: row.mwblj_value,
        }
        this.bj_dialog_domin = true;
      },

      // 确定编辑域名
      qdbjym(){
        if(
          this.form.zzym === '' ||
          this.form.gmrq === null ||
          this.form.dqrq === null ||
          this.form.dj === '' ||
          this.form.zh === '' ||
          this.form.mm === '' ||
          // this.form.qz === '' ||
          this.form.zt === '' ||
          this.form.zxr === '' ||
          this.form.bktjfs === '' ||
          this.form.gxzps === '' ||
          this.form.zjgxrq === null ||
          this.form.gjc_value === '' ||
          this.form.mwblj_value === ''
          ){
            this.$message.error('表单信息填写不完整，请检查后确认提交！！！');
            return false;
        }

        var s = this.form.gjc_value.split(', ');
        var p = this.form.mwblj_value.split(' ');
        if(s.length !== p.length){
          this.$message.error('关键词数量和锚文本数量不一致，请检查后确认提交！！！');
          return false;
        }

        if(this.form.gmrq !== ''){
          this.form.gmrq = this.$moment(new Date(this.form.gmrq)).format('YYYY-MM-DD');
        }
        if(this.form.dqrq !== ''){
          this.form.dqrq = this.$moment(new Date(this.form.dqrq)).format('YYYY-MM-DD');
        }
        if(this.form.zjgxrq !== ''){
          this.form.zjgxrq = this.$moment(new Date(this.form.zjgxrq)).format('YYYY-MM-DD');
        }
        this.loading = true;
        this.bj_dialog_domin = false;
        // console.log(this.form);
        editDomain(this.form).then(res => {
          if(res.code === 200){
            this.$message({
              message:res.msg,
              type:'success'
            })
          }else{
            this.$message({
              message:res.msg,
              type:'error'
            })
          }
          this.getDomain();
          this.loading = false;
        })
      },

      // 删除
      delete_(index,row){
        this.sc_domain_params = {
          blog:row.bkhtym
        }
        this.sc_dialog_domain = true;
      },

      // 确定删除
      SCYM(){
        this.loading = true;
        DeleteDomain(this.sc_domain_params).then(res => {
          if(res.code == 200){
            this.$message({
              message:res.msg,
              type:'success'
            })
            this.getDomain();
          }else{
            this.$message({
              message:res.msg,
              type:'error'
            })
            this.loading = false;
          }
        })
        this.sc_dialog_domain = false;
      }

    },

};
</script>

<style lang="scss" scoped>
.aaa{
  display: inline-block;
  width: 200px;
  margin-right: 10px;
}
.bbb{
  margin-right: 10px;
}
</style>